var _defs, _defs2, _path, _defs3, _path2, _defs4, _path3, _animate, _animate2, _animateTransform, _animateTransform2, _animate3, _animate4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: 436031667,
    viewBox: "0 0 285 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031667,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "436031667_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h285v0v189v0h-285v0v-189z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#436031667_clipPath)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "436031668_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,83,35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031668,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "436031668_fill_path",
    d: "M120,60c0,6.294 -0.99,12.552 -2.934,18.54c-1.944,5.988 -4.824,11.634 -8.526,16.728c-3.702,5.094 -8.178,9.57 -13.272,13.272c-5.094,3.702 -10.74,6.582 -16.728,8.526c-5.988,1.944 -12.246,2.934 -18.54,2.934c-6.294,0 -12.552,-0.99 -18.54,-2.934c-5.988,-1.944 -11.634,-4.824 -16.728,-8.526c-5.094,-3.702 -9.57,-8.178 -13.272,-13.272c-3.702,-5.094 -6.582,-10.74 -8.526,-16.728c-1.944,-5.988 -2.934,-12.246 -2.934,-18.54c0,-6.294 0.99,-12.552 2.934,-18.54c1.944,-5.988 4.824,-11.634 8.526,-16.728c3.702,-5.094 8.178,-9.57 13.272,-13.272c5.094,-3.702 10.74,-6.582 16.728,-8.526c5.988,-1.944 12.246,-2.934 18.54,-2.934c6.294,0 12.552,0.99 18.54,2.934c5.988,1.944 11.634,4.824 16.728,8.526c5.094,3.702 9.57,8.178 13.272,13.272c3.702,5.094 6.582,10.74 8.526,16.728c1.944,5.988 2.934,12.246 2.934,18.54z",
    fillRule: "nonzero",
    fill: "rgb(217, 217, 217)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "436031668_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,60c0,6.294 -0.99,12.552 -2.934,18.54c-1.944,5.988 -4.824,11.634 -8.526,16.728c-3.702,5.094 -8.178,9.57 -13.272,13.272c-5.094,3.702 -10.74,6.582 -16.728,8.526c-5.988,1.944 -12.246,2.934 -18.54,2.934c-6.294,0 -12.552,-0.99 -18.54,-2.934c-5.988,-1.944 -11.634,-4.824 -16.728,-8.526c-5.094,-3.702 -9.57,-8.178 -13.272,-13.272c-3.702,-5.094 -6.582,-10.74 -8.526,-16.728c-1.944,-5.988 -2.934,-12.246 -2.934,-18.54c0,-6.294 0.99,-12.552 2.934,-18.54c1.944,-5.988 4.824,-11.634 8.526,-16.728c3.702,-5.094 8.178,-9.57 13.272,-13.272c5.094,-3.702 10.74,-6.582 16.728,-8.526c5.988,-1.944 12.246,-2.934 18.54,-2.934c6.294,0 12.552,0.99 18.54,2.934c5.988,1.944 11.634,4.824 16.728,8.526c5.094,3.702 9.57,8.178 13.272,13.272c3.702,5.094 6.582,10.74 8.526,16.728c1.944,5.988 2.934,12.246 2.934,18.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "436031668_stroke_path",
    d: "M120,60c0,6.294 -0.99,12.552 -2.934,18.54c-1.944,5.988 -4.824,11.634 -8.526,16.728c-3.702,5.094 -8.178,9.57 -13.272,13.272c-5.094,3.702 -10.74,6.582 -16.728,8.526c-5.988,1.944 -12.246,2.934 -18.54,2.934c-6.294,0 -12.552,-0.99 -18.54,-2.934c-5.988,-1.944 -11.634,-4.824 -16.728,-8.526c-5.094,-3.702 -9.57,-8.178 -13.272,-13.272c-3.702,-5.094 -6.582,-10.74 -8.526,-16.728c-1.944,-5.988 -2.934,-12.246 -2.934,-18.54c0,-6.294 0.99,-12.552 2.934,-18.54c1.944,-5.988 4.824,-11.634 8.526,-16.728c3.702,-5.094 8.178,-9.57 13.272,-13.272c5.094,-3.702 10.74,-6.582 16.728,-8.526c5.988,-1.944 12.246,-2.934 18.54,-2.934c6.294,0 12.552,0.99 18.54,2.934c5.988,1.944 11.634,4.824 16.728,8.526c5.094,3.702 9.57,8.178 13.272,13.272c3.702,5.094 6.582,10.74 8.526,16.728c1.944,5.988 2.934,12.246 2.934,18.54z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 10,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1,
    clipPath: "url(#436031668_stroke_clip_path)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#436031668_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246467991473532e-16,1.2246467991473532e-16,1,478,160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031669,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ljgpxnfn21808388061572903",
    x1: 350,
    y1: -9.184851394388759e-15,
    x2: 350,
    y2: 299.99999999999994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(85, 66, 138)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(123, 97, 255)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "436031669_fill_path",
    d: "M0,21.2766v278.7234h700v-278.7234c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766z",
    fillRule: "nonzero",
    fill: "url(#ljgpxnfn21808388061572903)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "436031669_fill_path",
    d: "M0,21.2766v278.7234h700v-278.7234c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-179,142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031670,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ljgpxng5023407747272655932",
    x1: 350,
    y1: -9.184851394388759e-15,
    x2: 350,
    y2: 299.99999999999994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "rgb(85, 66, 138)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "rgb(123, 97, 255)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "436031670_fill_path",
    d: "M0,21.2766v278.7234h700v-278.7234c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766c0,0 -25.03584,21.2766 -43.75,21.2766c-18.71416,0 -43.75,-21.2766 -43.75,-21.2766c0,0 -25.03584,-21.2766 -43.75,-21.2766c-18.71416,0 -43.75,21.2766 -43.75,21.2766z",
    fillRule: "nonzero",
    fill: "url(#ljgpxng5023407747272655932)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,113,63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031693,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,16.911299999999997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031691,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "436031691_fill_path",
    d: "M9.67399,0c-0.48325,5.38612 1.334,16.04081 12.01207,18.64431c13.25488,3.23159 18.01831,4.97182 19.26086,8.45205c0.75938,3.39735 0,10.19227 -9.11254,10.19227c-4.28025,0.33129 -12.79933,-1.24295 -12.63361,-10.19227h-10.35525c-0.20712,4.97182 1.9468,15.76059 12.21926,19.14136c-1.23546,0.20473 -2.99039,0.19779 -4.99678,-0.24841c-0.43137,-0.09609 -0.87438,-0.21235 -1.32635,-0.35122c-3.03389,-0.89128 -5.47397,-2.23884 -7.42282,-3.82652c-3.348,-2.58514 -5.30944,-6.03378 -6.34514,-9.63923c-0.13163,-0.44911 -0.24309,-0.88859 -0.33613,-1.31463c-1.03662,-4.60155 -0.67752,-9.31734 0.14079,-12.71066c1.04457,-5.58355 3.62951,-11.91525 8.89563,-18.14704z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,18.8305,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031692,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "436031692_fill_path",
    d: "M31.49562,46.36719c0.48317,-5.38621 -1.334,-16.04081 -12.01214,-18.64431c-13.25488,-3.23159 -18.0183,-4.97182 -19.26086,-8.45202c-0.75943,-3.39742 0,-10.19222 9.11254,-10.19222c4.28025,-0.33145 12.79933,1.24295 12.6336,10.19222h10.35528c0.20715,-4.97182 -1.94688,-15.76063 -12.2193,-19.14147c1.23546,-0.20456 2.9903,-0.19766 4.99671,0.24859c0.43148,0.09594 0.87453,0.2122 1.32653,0.35103c3.03378,0.89148 5.47391,2.23901 7.42265,3.82653c3.34806,2.58521 5.30949,6.03398 6.34526,9.63943c0.13157,0.44911 0.24299,0.88846 0.33611,1.31441c1.03652,4.60164 0.67745,9.31745 -0.1409,12.71077c-1.04454,5.58355 -3.62949,11.91525 -8.8955,18.14704z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,113,63.0002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031682,
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,16.911400000000008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031683,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "436031683_fill_path",
    d: "M9.67399,0c-0.48325,5.38612 1.334,16.04081 12.01207,18.64431c13.25488,3.23159 18.01831,4.97182 19.26086,8.45205c0.75938,3.39735 0,10.19227 -9.11255,10.19227c-4.28025,0.33129 -12.79933,-1.24295 -12.63361,-10.19227h-10.35525c-0.20712,4.97182 1.9468,15.76059 12.21926,19.14136c-1.23546,0.20473 -2.99039,0.19779 -4.99678,-0.24841c-0.43137,-0.09609 -0.87438,-0.21235 -1.32635,-0.35122c-3.03389,-0.89128 -5.47397,-2.23884 -7.42282,-3.82652c-3.348,-2.58514 -5.30944,-6.03378 -6.34514,-9.63922c-0.13163,-0.44911 -0.24309,-0.88859 -0.33613,-1.31463c-1.03662,-4.60155 -0.67752,-9.31734 0.14079,-12.71066c1.04457,-5.58355 3.62951,-11.91525 8.89563,-18.14704z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,18.8305,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 436031684,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "436031684_fill_path",
    d: "M31.49562,46.36719c0.48317,-5.38621 -1.334,-16.04081 -12.01214,-18.64431c-13.25488,-3.23159 -18.0183,-4.97182 -19.26085,-8.45202c-0.75943,-3.39742 0,-10.19223 9.11254,-10.19223c4.28025,-0.33145 12.79932,1.24295 12.6336,10.19223h10.35528c0.20715,-4.97182 -1.94688,-15.76063 -12.2193,-19.14147c1.23546,-0.20456 2.9903,-0.19766 4.99671,0.24859c0.43148,0.09594 0.87453,0.2122 1.32653,0.35103c3.03378,0.89148 5.47391,2.23901 7.42265,3.82653c3.34806,2.58521 5.30949,6.03398 6.34526,9.63943c0.13157,0.44911 0.24299,0.88846 0.33611,1.31441c1.03652,4.60164 0.67745,9.31745 -0.1409,12.71077c-1.04454,5.58355 -3.6295,11.91525 -8.8955,18.14704z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  })))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#436031668_stroke_path",
    attributeName: "stroke",
    values: "rgb(255, 255, 255;rgb(255, 255, 255;rgb(255, 255, 255",
    dur: "4.001s",
    repeatCount: "indefinite",
    keyTimes: "0;0;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#436031668_stroke_path",
    attributeName: "stroke-opacity",
    values: "1;1;0",
    dur: "4.001s",
    repeatCount: "indefinite",
    keyTimes: "0;0;1",
    fill: "freeze"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#436031669",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 0;-243 -147",
    dur: "4.001s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0;1",
    keySplines: "0 0 0.15 1;0 0 0.58 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#436031670",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 0;251 -134",
    dur: "4.001s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0;1",
    keySplines: "0 0 0.15 1;0 0 0.58 1",
    additive: "sum",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#436031693",
    attributeName: "opacity",
    values: "1;1;0",
    dur: "4.001s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0;1",
    keySplines: "0 0 0.15 1;0 0 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#436031682",
    attributeName: "opacity",
    values: "0;0;1",
    dur: "4.001s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0;1",
    keySplines: "0 0 0.15 1;0 0 0.15 1",
    additive: "sum",
    fill: "freeze"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStLoader);
export default __webpack_public_path__ + "static/media/st-loader.ccd181be41e028fb3443e6e4f3b3732e.svg";
export { ForwardRef as ReactComponent };